import { makeStyles } from "@material-ui/core/styles";

const updateFieldSelectorStyles = makeStyles((theme) => ({
	form: {
		padding: theme.spacing(2),
		display: "flex",
		flexDirection: "column",
		height: "100%",
		justifyContent: "space-between"
	},
	spacer: {
		margin: "0 10px"
	},
	radioLeft: {
		marginLeft: 60
	},
	radioRight: {
		marginRight: 60
	},
	downOptions: {
		padding: "10px 0",
		alignSelf: "center"
	},
	mainPanel: {
		overflowY: "auto",
		padding: "20px",
		[theme.breakpoints.only("xs")]: {
			overflowX: "hidden"
		}
	},
	teamPosessionContainer: {
		[theme.breakpoints.only("xs")]: {
			maxWidth: "265px"
		}
	}
}));

export default updateFieldSelectorStyles;
